import { gql } from '@apollo/client';

export const SUBMIT_FEEDBACK_MUTATION = gql`
  mutation submitFeedback($input: AnalysisFeedbackInput!) {
    submitFeedback(input: $input) {
      feedbackId
      jobId
      storyId
      draftId
      userId
      overallThumb
      overallComment
      sentimentThumb
      sentimentCorrection
      topicThumb
      topicCorrection
      createdAt
      retrainingTriggered
    }
  }
`;
